import { useTranslation } from 'react-i18next';
import { useNavV6 } from './useNavV6';

/**
 * Label translation for pages that are shared with the OLD navigation. With the new navigation OFF it returns
 * the page's original literal untouched (so nothing changes at all); with it ON it returns the translated
 * label (Arabic by default for Arabic users, the same English text for English users: the English values
 * in en.json equal the literals). Labels only: no logic, no layout.
 *
 *   const nt = useNavT();   nt('nav6.sched.pick_device', 'Pick a device')
 */
export function useNavT() {
  const on = useNavV6();
  const { t } = useTranslation();
  const nt = (key, en, opts) => (on ? t(key, { defaultValue: en, ...(opts || {}) }) : (opts ? interpolate(en, opts) : en));
  nt.on = on;
  return nt;
}

// OFF path with variables: the original literals are static strings, so only plain {{x}} substitution is needed.
function interpolate(en, opts) {
  return String(en).replace(/\{\{(\w+)\}\}/g, (_, k) => (opts[k] === undefined ? '' : opts[k]));
}

export default useNavT;
